import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { routes } from './routes.js';
import './router.css';

const routeList = [...routes];

class Router extends React.Component {
  render() {
    return (
      <Switch>
        {routeList.map((route, routeIndex) => {
          if (route.permission) {
            // if (permissionHelper.hasUserPermission(route.permission)) {
              return (
                <Route
                  key={routeIndex}
                  exact={!!route.exact}
                  path={route.path}
                  component={route.component}
                  {...route}
                />
              );
            // }
          } else {
            return (
              <Route key={routeIndex} exact={!!route.exact} path={route.path} component={route.component} />
            );
          }
        })}
      </Switch>
    );
  }
}

// const mapStateToProps = state => ({
//   userPermissions:
//     state.authReducer.meInfo && state.authReducer.meInfo.selectedRole
//       ? state.authReducer.meInfo.selectedRole.permissions
//       : []
// });

export default Router;
